export const DiffBasketUtil = {
  getDiffPersons(oldBasket, newBasket) {
    if (oldBasket.length === 0 || newBasket.length === 0) return []
    let personMap = new Map()
    let categories = {}

    newBasket.forEach(p => {
      fillCategories(categories, p, MODE.CHANGED)
      mapPerson(personMap, p, MODE.CHANGED)
    })

    oldBasket.forEach(p => {
      fillCategories(categories, p, MODE.EXISTING)
      mapPerson(personMap, p, MODE.EXISTING)
    })

    addSortedCategoriesToMap(personMap, categories)
    return [...personMap.values()]
  },
}

const MODE = {
  CHANGED: 'changed',
  EXISTING: 'existing',
}

const category_sort = {
  KVG: 0,
  HOSP: 1,
  ADDITIONAL: 2,
  OTHER: 3,
}

function addSortedCategoriesToMap(personMap, categories) {
  for (let [key, value] of personMap) {
    value.diffProducts = Object.values(categories[key]).sort((a, b) => category_sort[a.id] - category_sort[b.id])
  }
}

function fillCategories(currentCategories, person, mode) {
  const partnerNumber = person.partnerNumber
  person.selectedProducts.forEach(category => {
    currentCategories = addCategoryToList(currentCategories, partnerNumber, category, mode)
  })
}

function mergeProducts(existingProducts, newProducts) {
  return Object.assign({}, existingProducts, {
    products: Object.assign({}, existingProducts.products, newProducts),
  })
}

function mapPerson(personMap, person, mode) {
  const partnerNumber = person.partnerNumber
  const existingProducts = personMap.get(partnerNumber)?.products || {}
  personMap.set(
    partnerNumber,
    Object.assign({}, personMap.get(partnerNumber), {
      age: person.age,
      personId: person.personId,
      contractNumber: person.contractNumber,
      partnerNumber: person.partnerNumber,
      personData: person.personData,
      products: mergeProducts(existingProducts, person.products.products), // Still needed for OvpProduct-Component
      selectedProducts: person.selectedProducts, // Still needed for OvpProduct-Component
      [mode]: {
        total: person.total,
      },
    })
  )
}

function addCategoryToList(currentCategories, partnerNumber, category, mode) {
  if (!currentCategories[partnerNumber]) {
    currentCategories[partnerNumber] = {}
  }
  currentCategories[partnerNumber][category.id] = Object.assign({}, currentCategories[partnerNumber][category.id], {
    id: category.id,
    [mode]: category.products,
  })
  return currentCategories
}
